import React from 'react';
import './App.css'; 

const Home = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.png" alt="Logo"/>
        <p className="centered-paragraph">
    Surf the web on your watch! Quick access to favorites. Elevate your browsing experience now with fast web navigation, smart search, and seamless connectivity for your smartwatch. Enjoy a smooth and efficient browsing experience directly from your wrist!
</p>

        <a href='https://apps.apple.com/app/surfify-web-browser-on-watch/id6478813759?ppid=121505f9-a6b7-4285-b495-15bdd2bac71d'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <div id="links">
  <a href='/privacyPolicy'>Privacy Policy</a> |
  <a href='/termsOfUs'>Terms Of Use</a> |
  <a href='/accessibilityStatement'>Accessibility Statement</a> |
  <a href="mailto:devapp555@outlook.com?subject=Surfify app" aria-label="Contact us via email" className="contact-button">Contact Us</a>
</div>
        </div>
        </>
     );
}
 
export default Home;